/**
 * Attempts to close the current browser tab.
 *
 * window.close() is a no-op in most browsers unless the tab was opened via
 * window.open() or this is called synchronously from a genuine user-gesture
 * handler (e.g. a button click) - it will not work from a bare timer callback.
 * Since a blocked close fails silently, we detect it and let the caller show
 * a fallback (e.g. "you may now close this tab") instead of leaving the user
 * looking at a page that appears to have done nothing.
 */
export function closeTab(onBlocked?: () => void): void {
  window.close();

  setTimeout(() => {
    if (!window.closed) {
      onBlocked?.();
    }
  }, 300);
}
